import React from 'react';
import { Alert } from 'antd';
import { Link } from 'react-router-dom';
import { ManagedBy } from '../../service/delegation.service';

interface Props {
  managedBy: ManagedBy | null;
  setting: string;
}

/** Tells the viewer which console owns a setting. Without an id the owner is out of reach, so no link or name. */
const ManagedByBanner: React.FC<Props> = ({ managedBy, setting }) => {
  if (!managedBy) return null;
  const hasTarget = managedBy.id != null;
  const path = managedBy.kind === 'entity' ? 'entity' : 'org';
  return (
    <Alert
      type="info"
      showIcon
      style={{ marginBottom: 16 }}
      message={
        hasTarget ? (
          <span>
            The {setting} settings are managed by{' '}
            <Link 
              to={`/${path}/${managedBy.id}`}
            >{managedBy.name ?? `${managedBy.kind} ${managedBy.id}`}</Link>.
          </span>
        ) : (
          <span>Managed by your organisation</span>
        )
      }
    />
  );
};

export default ManagedByBanner;
